// SpawnManager.js
var SpawnManager = pc.createScript('spawnManager');
SpawnManager.attributes.add('SpawnPosition',{type: 'entity'});;

var roomObjectList =[];

SpawnManager.prototype.initialize = function () {
    
    this.log = new Log("SPAWN_MANAGER");
    SpawnManager.instance = this;

    this.app.on("spawnManager:Start",this.spawninitalize,this);
    this.entity.on("destroy", this.OnDestroy,this);
};

SpawnManager.prototype.spawninitalize = function (assetsName, objectCount) {

    let levelName = "";

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {

        this.assetsList = this.app.assets.findByTag(GameManager.instance.placeData.levelTemplate);
        levelName = GameManager.instance.placeData.levelTemplate;
        this.prepareSpawnObjectList(this.assetsList,true,levelName,false);
    }
    else if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal) {

        this.assetsList = this.app.assets.findByTag(PlayerManager.instance.levelData.levelTemplate);
        levelName = PlayerManager.instance.levelData.levelTemplate;

        if (PlayerManager.instance.userData.interruption == 1) {

            roomObjectList.forEach((entryID) => {
    
                var instance = this.app.assets.get(entryID).resource.instantiate();
                instance.name = entryID;
                instance.setPosition(this.SpawnPosition.getPosition().x, this.SpawnPosition.getPosition().y, this.SpawnPosition.getPosition().z);
    
                var instanceTwo = instance.clone();
                this.SpawnPosition.addChild(instance);
                this.SpawnPosition.addChild(instanceTwo);
            });
        }
        else {
            this.prepareSpawnObjectList(this.assetsList,true,levelName,false);
        }     
    }
    else if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {

        this.assetsList = this.app.assets.findByTag(assetsName);
        levelName = assetsName;
        
        if (assetsName == "Number"){
            this.prepareSpawnObjectList(this.assetsList,false,levelName,true);
        }
        else {
            this.prepareSpawnObjectList(this.assetsList,false,levelName,false);
        }
    }
};

SpawnManager.prototype.prepareSpawnObjectList = function(assetsList,isRandomAssetList,levelName,isSingleObject) {

    let isImpulse = ((levelName == "School") || (levelName == "Number")) ? true : false;
    
    if (levelName == "DonutShop") { isRandomAssetList = false; }

    if (isRandomAssetList) {

        for (i = 0; i < spawnAssetRandomIndexes.length; i++) {
            var selectedIndex = spawnAssetRandomIndexes[i];
            this.Spawn(assetsList[selectedIndex], isSingleObject, isImpulse);
        }
    }
    else {
        
        for (i = 0; i < assetsList.length; i++) {
            this.Spawn(assetsList[i], isSingleObject, isImpulse);
        }
    }

    //this.log.info("Level Template Name: " + levelName);
    //this.log.info("Sahneye Basılan Obje Çifti Sayısı: " + this.SpawnPosition.children.length);
};

SpawnManager.prototype.eventAttentionSpawn = function (priorityAssetTag, poolAssetTag, objectCount) {
    
    var thrownObjectCount = 0, counter = 0;

    for (i = 0; i < priorityAssetTag.length; i++) {
        priorityAssetList = this.app.assets.findByTag(priorityAssetTag[i])[0];
        this.Spawn(priorityAssetList, false, false);
    }

    var poolAsset = this.app.assets.findByTag(poolAssetTag);

    let expectedSpawnObjectCount = objectCount - priorityAssetTag.length;
    let availableAssetListCount = poolAsset.length - priorityAssetTag.length;
    let spawnCount = 0;
    
    if (expectedSpawnObjectCount <= availableAssetListCount) {
        spawnCount = expectedSpawnObjectCount;
    }
    else {
        spawnCount = availableAssetListCount;
    }

    counter = 0;

    while (thrownObjectCount < spawnCount) {

        if (counter < poolAsset.length) {
            if (SpawnManager.instance.checkEntityHasTag(poolAsset[counter], priorityAssetTag) == false) {
                this.Spawn(poolAsset[counter], false, false);
                thrownObjectCount++;
            }
            counter++;
        }
        else {
            break;
        }
    }
    //this.log.info("Sahneye Basılan Obje Çifti Sayısı: " + this.SpawnPosition.children.length);
};

SpawnManager.prototype.checkEntityHasTag = function(inputEntity, tagList) {

    let returnVal = false;
    for (i=0; i<tagList.length; i++) {
        
        if (inputEntity.tags.has(tagList[i])) {
            returnVal = true;
            break;
        }
    }
    return returnVal;
};

SpawnManager.prototype.eventMultipleAssetInitialize = function(priorityAssetTag,poolAssetTag,objectCount) {
 
    var thrownObjectCount=0;
    
    priorityAssetList = this.app.assets.findByTag(priorityAssetTag);
    
    
    let expectedPriorityLength = priorityAssetList.length>14 ? 14 : priorityAssetList.length;

    var priorityObjectRandomArray = [];
    matchThemeAssetList = [];
    
    while (priorityObjectRandomArray.length < expectedPriorityLength) {
        var r = Math.floor(Math.random() * (priorityAssetList.length));
        if (priorityObjectRandomArray.indexOf(r) === -1) priorityObjectRandomArray.push(r);
    }

    for (i = 0; i < priorityObjectRandomArray.length; i++) {
        matchThemeAssetList.push(priorityAssetList[priorityObjectRandomArray[i]]);
        this.Spawn(priorityAssetList[priorityObjectRandomArray[i]], false, false);
    }
    
    let poolAsset = this.app.assets.findByTag(poolAssetTag[0]);
    let expectedSpawnObjectCount = objectCount - expectedPriorityLength;
    let availableAssetListCount = poolAsset.length - expectedPriorityLength;

    let spawnCount = 0;
    
    if (expectedSpawnObjectCount <= availableAssetListCount) {
        spawnCount = expectedSpawnObjectCount;
    }
    else {
        spawnCount = availableAssetListCount;
    }

    counter = 0;

    while (thrownObjectCount < spawnCount) {
        
        if (counter < poolAsset.length) {

            if ((poolAsset[counter].tags.has(priorityAssetTag) == false)) {
                this.Spawn(poolAsset[counter], false, false);
                thrownObjectCount++;
            }
            counter++;
        }
        else {
            break;
        }
    }
    //("Sahneye Basılan Obje Çifti Sayısı: " + this.SpawnPosition.children.length);
};


SpawnManager.prototype.Spawn = function(spawnObject, isSingleObject, isStrongImpulse){

    var instance = spawnObject.resource.instantiate();
    instance.name = spawnObject.id;
   
    //Daily Events'ler elle yapılan tag atamasındaki anahtar tagin atanması
    if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
        instance.tags.add(spawnObject.tags.list()[2]);
    }
    
    // Atılan Objelerin İsimlerini Hafızaya Alınması
    roomObjectList.push(instance.name);
    
    instance.setPosition(this.SpawnPosition.getPosition().x, this.SpawnPosition.getPosition().y, this.SpawnPosition.getPosition().z);
    
    var applyImpulseObject = function (inputObject, isStrong) {

        if (isStrong) {
            inputObject.rigidbody.applyImpulse(0, 17, 0);
        }
        else {
            inputObject.rigidbody.applyImpulse(0, 6.5, 0);
        }
    };

    this.SpawnPosition.addChild(instance);

    applyImpulseObject(instance,isStrongImpulse);
    
    //Single Object Math Mini Game'i İçin Geçerli
    if (!isSingleObject) {
       
        var instanceTwo = instance.clone();
        this.SpawnPosition.addChild(instanceTwo);
        applyImpulseObject(instanceTwo,isStrongImpulse);
    }
};

SpawnManager.prototype.OnDestroy = function(){

    this.app.off("spawnManager:Start", this.resetBar,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

SpawnManager.prototype.clearObjects = function() {

    for (i = this.SpawnPosition.children.length-1; i>=0; i--) {
        this.SpawnPosition.children[i].destroy();
    }
};



